var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17644_53980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 0.794922C7.58252 9.4298 2.19922 10.2916 9.37695 16.336C16.5547 10.2916 11.1714 9.42974 9.37695 0.794922ZM4.89087 5.96997C3.99365 8.56044 2.19922 10.3009 2.19922 12.8914C2.19922 15.4818 5.78809 17.2012 8.47974 17.2012C3.09644 12.8837 4.89087 10.2874 4.89087 5.96997ZM13.863 5.96997C13.863 10.2874 15.6575 12.8838 10.2742 17.2012C12.9658 17.2012 16.5547 15.4818 16.5547 12.8914C16.5547 10.3009 14.7603 8.56044 13.863 5.96997Z",
    fill: "#E60000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17644_53980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "translate(0.625 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.8a35101fd24ba04fde44155a8fb13583.svg";
export { ForwardRef as ReactComponent };